import React from "react";
import LiabilityInfo from "./LiabilityInfo";

interface LiabilityProps {
  form: any;
}

const LiabilityData = ({ form }: LiabilityProps) => {
  return (
    <div className="takaful--recipient-container">
      <LiabilityInfo form={form} />
    </div>
  );
};

export default LiabilityData;
